import GFIcon from 'assets/icons/GFIcon.svg'

export default GFIcon
